import axios from "axios";
import AuthService from "@/services/AuthService";
import LangService from "@/services/LangService";
import siteConfiguration from '@/config';

export const HTTP = axios.create({
  baseURL: siteConfiguration.API_URL,
  headers: {
    "cache-control": "no-cache",
    "accept-language": LangService.getAcceptLanguageLang(),
    authorization: ""
  }
});

HTTP.interceptors.request.use(
  function (config) {
    const token = AuthService.getIdToken();
    if (token !== null) {
      config.headers.authorization = `Bearer ${token}`;
    }
    const lang = LangService.getAcceptLanguageLang();
    config.headers.acceptLanguage = lang;

    return config;
  },
  function (err) {
    return Promise.reject(err);
  }
);

HTTP.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // Prevent endless redirects (login is where you should end up)
    if (error.request !== undefined) {
      if (error.request.responseURL.includes("login")) {
        return Promise.reject(error);
      }
    }

    // If you can't refresh your token or you are sent Unauthorized on any request, logout and go to login
    if (
      error.request !== undefined &&
      (error.request.responseURL.includes("refresh") ||
        (error.request.status === 401 && error.config.__isRetryRequest))
    ) {
      AuthService.logout();
    } else if (error.request !== undefined && error.request.status === 401) {
      error.config.__isRetryRequest = true;
      return HTTP.request(error.config);
    }
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/http/index.js